import React from "react";
import { getAllBooks } from "../../services/Book";
import Book from "../Book/Book";
import "./OurBook.css";
import ScrollTo from "../../helpers/scroll";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as LoaderActions } from "../../store/ducks/loader";

class OurBooks extends React.Component {
  constructor(props) {
    super(props);
    window.scrollTo(0,0);
    this.state = {
      books: []
    };
  }

  async componentDidMount() {
    console.log(this.props);
    const { isLoading } = this.props;
    isLoading(true);
    try {
      let { data: books } = await getAllBooks();

      books = books.map(book => {
        book.price = book.price.toFixed(2).replace(".", ",");
        return book;
      });
      await this.setState({ books: books });
    } catch (Error) {
      alert("Erro ao buscar livros, recarregue a sua página!");
    }
    isLoading(false);
    const element = document.querySelector(`#OurBooks`);
    const to = element.offsetTop;
        window.scroll({
            top: to - -20,
            behavior: "smooth"
        });
  }

  render() {
    return (
      <div id="OurBooks" className="ourbooks mt-5 mb-4">
        <div className="phrase mb-5">
          <p className="text-color">
            A leitura de um bom livro é o caminho mais curto<br/> para se descobrir
            que a vida vale a pena.
          </p>
          <p className="phrase-author text-color">Antonio Costta</p>
        </div>
        <h3 className="title-ourbooks mb-5">NOSSOS LIVROS</h3>

        <div id="nossosLivros" className="ourbooks-books">
          {this.state.books.map((book, index) => (
            <div style={{ margin: "10px 7px" }} key={index}>
              <Book
                key={book._id}
                history={this.props.history}
                data={book}
                title={book.title}
                price={book.price}
                author={book.author}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(LoaderActions, dispatch);

export default connect(
  null,
  mapDispatchToProps
)(OurBooks);



// WEBPACK FOOTER //
// ./src/components/OurBooks/OurBooks.js